import EntitlementsRole from './entitlementsRole';
import SuggestionTypes from './suggestionTypes';
import FeatureFlags from './featureFlags';

const { ADDRESS, LOCALITY } = SuggestionTypes;

const REPORT_ENTITLEMENTS = [
    EntitlementsRole.PROPERTY_CMA,
    EntitlementsRole.RENTAL_CMA,
    EntitlementsRole.CMA_GENERIC_REPORT_ENGINE_FULL,
    EntitlementsRole.PROFILER_PROPERTY_ONE_PAGE,
    EntitlementsRole.PROPERTY_PROFILER,
    EntitlementsRole.VALUATION,
    EntitlementsRole.PROFILER_SUBURB,
    EntitlementsRole.RENTAL_AVM_FULL,
    EntitlementsRole.DIGITAL_PROPERTY_PROFILE,
    EntitlementsRole.TITLES_REPORT,
    EntitlementsRole.SUBURB_STATISTICS,
    EntitlementsRole.EXPORT_LIMIT_PRO,
    EntitlementsRole.PROPOSAL_POINT,
    EntitlementsRole.MAP_ADVANCED,
].map(e => e.toLowerCase());

const DISPLAY_TYPE = {
    REPORT: 'REPORT',
    PANEL: 'PANEL',
};

const SIGNATURE_REPORT_TYPES = {
    SOI: 'soi',
    CMA: 'cma',
    RENTAL: 'rental',
};

const OWNER_NAMES = {
    available: 'Include Owner Names',
    notAvailable: 'Owner names not available due to supplier restrictions',
};

const PDF_REPORT_KEYS = {
    summary: 'summary',
    propertyProfile: 'propertyProfile',
    suburbProfile: 'suburbProfile',
    intellival: 'intellival',
    propertyInvestment: 'propertyInvestment',
};

const DIGITAL_RPOPERTY_REPORT  = {
    label: 'Digital Property Report',
    value: 'digitalReport',
    suggestionType: [ADDRESS],
    entitlements: EntitlementsRole.DIGITAL_PROPERTY_PROFILE,
};
const CMA_REPORT = {
    label: 'CMA Report',
    value: 'cmaReport',
    suggestionType: [ADDRESS],
    entitlements: EntitlementsRole.PROPERTY_CMA,
};

const ONE_PAGE_REPORT = {
    label: '1 Page PDF',
    value: 'onePageReport',
    suggestionType: [ADDRESS],
    entitlements: EntitlementsRole.PROFILER_PROPERTY_ONE_PAGE,
}

const PROPERTY_REPORTS = {
    label: 'Property Report',
    value: 'propertyReport',
    suggestionType: [ADDRESS],
    entitlements: EntitlementsRole.PROPERTY_PROFILER,
};

const RENTAL_CMA_REPORT = {
    label: 'Rental CMA Report',
    value: 'rentalCmaReport',
    suggestionType: [ADDRESS],
    entitlements: EntitlementsRole.RENTAL_CMA,
};

const SUBURB_STATS_REPORT = {
    label: 'Suburb Statistics Report',
    value: 'suburbStatsReport',
    suggestionType: [LOCALITY],
    entitlements: EntitlementsRole.SUBURB_STATISTICS,
}

const EQUITY_CALCULATOR_REPORT = {
    label: 'Equity Calculator Report',
    value: 'equityCalculatorReport',
    suggestionType: [ADDRESS],
    entitlements: EntitlementsRole.EXPORT_LIMIT_PRO,
    featureFlag: FeatureFlags.EQUITY_REPORT,
}

const REPORT_TYPES_AU = {
    digitalReport: DIGITAL_RPOPERTY_REPORT,
    equityCalculatorReport: EQUITY_CALCULATOR_REPORT,
    cmaReport: CMA_REPORT,
    onePageReport: ONE_PAGE_REPORT,
    valuationEstimate: {
        label: 'Valuation Estimate',
        value: 'valuationEstimate',
        suggestionType: [ADDRESS],
        entitlements: EntitlementsRole.VALUATION
    },
    propertyReport: PROPERTY_REPORTS,
    proposal: {
        label: 'Proposal',
        value: 'proposal',
        suggestionType: [ADDRESS],
        entitlements: EntitlementsRole.PROPOSAL_POINT,
    },
    suburbReport: {
        label: 'Suburb Report',
        value: 'suburbReport',
        suggestionType: [LOCALITY],
        entitlements: EntitlementsRole.PROFILER_SUBURB,
    },
    rentalEstimate: {
        label: 'Rental Estimate',
        value: 'rentalEstimate',
        suggestionType: [ADDRESS],
        entitlements: EntitlementsRole.RENTAL_AVM_FULL,
    },
    rentalCmaReport: RENTAL_CMA_REPORT,
    soi: {
        label: 'Statement of Information',
        value: 'soi',
        suggestionType: [ADDRESS],
        entitlements: EntitlementsRole.CMA_GENERIC_REPORT_ENGINE_FULL,
    },
    suburbStats: SUBURB_STATS_REPORT,
    propertyInvestment: {
        label: 'Property Investment Report',
        value: 'propertyInvestment',
        suggestionType: [ADDRESS],
        entitlements: EntitlementsRole.EXPORT_LIMIT_PRO,
        featureFlag: 'crux-property-investment-report',
    },
};

const REPORT_TYPES_NZ = {
    digitalReport: DIGITAL_RPOPERTY_REPORT,
    equityCalculatorReport: EQUITY_CALCULATOR_REPORT,
    cmaReport: CMA_REPORT,
    onePageReport: ONE_PAGE_REPORT,
    propertyReport: PROPERTY_REPORTS,
    rentalCmaReport: RENTAL_CMA_REPORT,
    titleReport: {
        label: 'Title Report',
        value: 'titleReport',
        suggestionType: [ADDRESS],
        entitlements: EntitlementsRole.TITLES_REPORT,
    },
    suburbStats: SUBURB_STATS_REPORT,
};

const CES_REPORT_TYPES = {
    digitalReport: DIGITAL_RPOPERTY_REPORT.value,
    equityCalculatorReport: EQUITY_CALCULATOR_REPORT.value,
}

export default {
    RENTAL_ESTIMATE: 'Rental Estimate Report',
    ONE_PAGE: '1 Page Report',
    PROPERTY_REPORT: 'Property Report',
    PROPERTY_INVESTMENT_REPORT: 'Property Investment Report',
    SUBURB_REPORT: 'Suburb Report',
    INTELLIVAL_AVM_REPORT: 'Intellival AVM Report',
    REPORT_ID: {
        valuationReport: 108,
        propertyReportWithoutAvm: 29,
        propertyReportWithAvm: 18,
        rentalAvmEstimateReport: 28,
        suburbReport: 4,
    },
    REPORT_ENTITLEMENTS,
    OWNER_NAMES,
    SIGNATURE_REPORT_TYPES,
    PDF_REPORT_KEYS,
    DISPLAY_TYPE,
    REPORT_TYPES_AU,
    REPORT_TYPES_NZ,
    CES_REPORT_TYPES,
};
